<script lang="ts">
  import {
    Row,
    Column,
    Button,
    InlineNotification
  } from 'carbon-components-svelte'
  import LobbyStore from '../stores/lobby'
  import GamesStore from '../stores/games'

  const { gameTypes, openGames } = LobbyStore
  const { openNewGame } = GamesStore

  const newGame = (gameType: string) => openNewGame(gameType)

</script>

<Row>
  <Column lg={16}>
    <h1 style="margin-bottom: 1.5rem">Open Games</h1>
  </Column>
</Row>
<Row>
  <Column lg={16}>
    {#each $openGames as openGame}
      <Button kind="secondary" > {openGame.gameTypeName}</Button>
    {/each}
    {#if $openGames.length === 0}
      <InlineNotification
        hideCloseButton
        lowContrast
        kind="info"
        subtitle="Start a new game below"
        title="No open games" />
    {/if}
  </Column>
</Row>
<Row>
  <Column lg={16}>
    <h1 style="margin-bottom: 1.5rem; margin-top:3rem">Start a new Game</h1>
  </Column>
</Row>
<Row>
  <Column lg={16}>
    {#each $gameTypes as gameType}
      <Button kind="secondary" style="margin: 1px" on:click={() => newGame(gameType)}>{gameType}</Button>
    {/each}
  </Column>
</Row>
